module.exports = __webpack_public_path__ + "img/type-bold.edb3ab7a.svg";